<template>
  <div id="summary">
    <div class="top-title border-b border-section_border" id="top-title">
      <h1 class="top-title-heading" v-html="$t('tour_main_title')"></h1>
    </div>
    <div class="py-4 bg-light_gray border-b border-section_border">
      <h2 class="section-title px-4 text-center text-lg">
        {{ datetime }} {{ title }}
      </h2>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    title: function () {
      return this.$store.getters['plans/getTitle']
    },
    datetime: function () {
      const date = this.$store.getters['condition/getTime']
      return date.format('YYYY/MM/DD')
    }
  }
}
</script>
